module.exports = __webpack_public_path__ + "static/img/Drew-Brees-Most-Completions.c112b30.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Drew-Brees-Most-Completions.gif
// module id = /2Tn
// module chunks = 1